import React from 'react';
import { Box, Typography } from '@mui/material';

const FooterComponent = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 1, // Padding top and bottom
        px: 2, // Padding left and right
        mt: 'auto', // This pushes the footer to the bottom of its flex container
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography variant="body2" color="text.secondary" align="center">
        {'© '}
        {new Date().getFullYear()}
        {' Jakub Paplhám, Machine Learning Group, Czech Technical University in Prague. All Rights Reserved.'}
      </Typography>
    </Box>
  );
};

export default FooterComponent;